import {Component, Input} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {BaseModalComponent} from '../base-modal.component';
import {User} from '../../_models/user';

@Component({
    selector: 'bb-clock-in-type',
    templateUrl: './clock-in-type.component.html',
    styleUrls: ['./clock-in-type.component.scss'],
})
export class ClockInTypeComponent extends BaseModalComponent {
    @Input() user: User;

    constructor(modalController: ModalController) {
        super(modalController);
    }
}
